export default __webpack_public_path__ + "static/media/brasil.f2df3f70.svg";